import React from 'react';
import { ButtonBase, Paper, Stack } from '@mui/material';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { withBrandName } from '../../../config/appConfig';
import { CLASSIFICATION_ORDER, CLASSIFICATION_TONES, PILL_TONES } from '../utils/reconConstants';

// Design-reference segmented pill group: a bordered card holding one toned
// pill per classification (default / amber / red / purple) with live counts.
const Pill = ({ active, label, count, tone, onClick }) => {
  const colors = PILL_TONES[tone] ?? PILL_TONES.default;
  return (
    <ButtonBase
      onClick={onClick}
      aria-pressed={active}
      sx={{
        px: 1.5,
        py: 0.5,
        borderRadius: 1,
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        fontVariantNumeric: 'tabular-nums',
        bgcolor: active ? colors.activeBg : 'transparent',
        color: active ? colors.activeText : colors.text,
        '&:hover': { bgcolor: active ? colors.activeBg : colors.bg },
        transition: 'background-color 120ms',
      }}
    >
      {label}
      {count !== undefined && count !== null ? ` · ${Number(count).toLocaleString()}` : ''}
    </ButtonBase>
  );
};

const ClassificationPills = ({ kpis, selected, onSelect }) => {
  const { reconciliation: r } = useTranslatedMessages();
  const counts = kpis?.classifications ?? {};

  return (
    <Paper variant="outlined" sx={{ p: 0.5, display: 'inline-flex', flexShrink: 0 }}>
      <Stack direction="row" spacing={0.5}>
        {CLASSIFICATION_ORDER.map((classification) => (
          <Pill
            key={classification}
            active={selected === classification}
            label={withBrandName(r.classifications?.[classification] ?? classification)}
            count={counts[classification]?.count}
            tone={CLASSIFICATION_TONES[classification]}
            onClick={() => onSelect(classification)}
          />
        ))}
      </Stack>
    </Paper>
  );
};

export default ClassificationPills;
